import { Toaster } from 'react-hot-toast';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';
import Main from './Layout/Main';
import Blog from './pages/Blog.js/Blog';
import Home from './pages/Home/Home';

function App() {
      const routes = createBrowserRouter([
        {
          path:'/',
          element: <Main />,
          children:[
            {
              path:'/',
              element: <Home />
            },
            {
              path:'/blog',
              element: <Blog />
            },
          ]
        }
      ])
           
  return (
    <div className="App bg-[#202327]">
      <Toaster
        position="top-center"
        reverseOrder={false}
      />
        <RouterProvider router={routes} />
    </div>
  );
}

export default App;
